export const SET_SUCCESS_MSG = 'setSuccessMsg';
export const SET_ERR_MSG = 'setErrMsg';
